import { render, staticRenderFns } from "./CreateItemGroupModal.vue?vue&type=template&id=4d1fe086&"
import script from "./CreateItemGroupModal.vue?vue&type=script&lang=ts&"
export * from "./CreateItemGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports